import { createReducer } from '../../utils';
import types from './types';

export const initialState = {
    flashMessages: [],
    displayHeaderFlashMessage: false,
    headerFlashMessage: {
        type: '',
        text: '',
        customIcon: '',
        clickCallback: null
    },
    errors: []
};

// TODO Add action handlers for createFlashMessage
const ASYNC_ACTION_HANDLERS = {
    // TODO This should not be an array for sure
    [types.FETCH_FLASH_MESSAGES.REQUEST]: state => ({
        ...state,
        headerFlashMessage: []
    }),

    [types.FETCH_FLASH_MESSAGES.ERROR]: (state, action) => ({
        ...state,
        errors: [...state.errors, action.payload]
    })
};

const SYNC_ACTION_HANDLERS = {
    [types.SHOW_FLASH_MESSAGE]: (state, action) => {
        // TODO Do not modify action, it should be immutable
        if (action.payload) {
            action.payload.seen = true;
        }

        return ({
            ...state,
            flashMessages: [...state.flashMessages, action.payload]
        });
    },

    // TODO Rename action and type bc it removes ALL flash messages
    [types.HIDE_FLASH_MESSAGE]: state => ({
        ...state,
        flashMessages: []
    }),

    [types.SHOW_HEADER_FLASH_MESSAGE]: (state, action) => ({
        ...state,
        displayHeaderFlashMessage: true,
        headerFlashMessage: {
            type: action.payload.type || '',
            text: action.payload.text || action.payload.message || '',
            customIcon: action.payload.customIcon || '',
            clickCallback: action.payload.clickCallback || null
        }
    }),

    // TODO No need to redefine this headerFlashMessage here, its default state
    // is in initialState already
    [types.HIDE_HEADER_FLASH_MESSAGE]: state => ({
        ...state,
        displayHeaderFlashMessage: false,
        headerFlashMessage: {
            type: '',
            text: '',
            customIcon: '',
            clickCallback: null
        }
    }),

    [types.REMOVE_SEEN_FLASH_MESSAGES]: (state, action) => ({
        ...state,
        flashMessages: action.payload
    })
};

const ACTION_HANDLERS = {
    ...ASYNC_ACTION_HANDLERS,
    ...SYNC_ACTION_HANDLERS
};

export default createReducer(ACTION_HANDLERS, initialState);
